
if (!customElements.get('skio-bundle')) {
  class SkioBundle extends HTMLElement {
    constructor() {
      super();
      this.product_id = this.dataset.productId;
      this.dynamic_box = null;
      this.box_products = null;
      this.filters = ['ALL'];
      this.active_filter = 'ALL';
      this.selling_plan = null;
      this.products_in_bag = [];
      this.min_bundle_size = null;
      this.max_bundle_size = null;
      this.percent_discount_tier = null;
      this.subscription_discount_value = Number(this.dataset.subscriptionDiscount);
    }

    getDynamicBox = (async (productPlatformId) => {
      const response = await fetch('https://api.skio.com/storefront-http/get-dynamic-box', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          productPlatformId
        }),
      });

      const data = await response.json();
      
      return data.DynamicBox;
    });

    getSellingPlan = (async (productVariantPlatformId) => {
      const response = await fetch('https://api.skio.com/storefront-v2-http/get-product-variant-selling-plans', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          productVariantPlatformId
        }),
      });

      const data = await response.json();
      const selling_plan = data.productVariant.sellingPlanGroups[0].sellingPlans;
      selling_plan.sort((a, b) => a.billingPolicy.intervalCount - b.billingPolicy.intervalCount);

      return selling_plan;
    });

    generateSellingPlanButtons = ((selling_plan) => {
      const selling_plan_container = this.querySelector('[data-skio-selling-plan]');

      selling_plan_container.innerHTML = `
        <div class="pb-2">Delivery Every</div>
        <div data-frequency-container class="hidden">
          ${selling_plan.map((plan, index) => `
            <button data-selling-plan data-value="${plan.platformId}" class="skio-frequency-btn ${index === 0 ? 'selected' : ''}">
            ${plan.billingPolicy.intervalCount} ${plan.billingPolicy.interval}S
          </button>
          `).join('')}
        </div>
      `

      selling_plan_container.addEventListener('click', (ev) => {
        const buttons = selling_plan_container.querySelectorAll('button');

        buttons.forEach(button => {
          if (button === ev.target) {
            button.classList.add('selected');
          } else {
            button.classList.remove('selected');
          }
        });
      });
    });

    handleSellingPlanChange = (() => {
      const subscription_checkbox = this.querySelector('[data-checkbox]');

      subscription_checkbox.checked = false;
      subscription_checkbox.addEventListener('change', (ev) => {
        const selling_plan_container = this.querySelector('[data-skio-selling-plan]');
        const frequency_buttons = selling_plan_container.querySelector('[data-frequency-container]');

        if (ev.target.checked) {
          selling_plan_container.classList.remove('!opacity-0');
          selling_plan_container.classList.remove('!max-h-0');
          frequency_buttons.classList.remove('hidden');
          frequency_buttons.classList.add('flex');
        } else {
          selling_plan_container.classList.add('!max-h-0');
          selling_plan_container.classList.add('!opacity-0');
          frequency_buttons.classList.add('hidden');
          frequency_buttons.classList.remove('flex');
        }

        this.updatePriceElements();
        this.updateBagTilePrice();
      });
    });

    generateProducTileMarkup = (product) =>  `
      <intersection-loader 
        data-url="/products/${product.productHandle}"
        data-section-id="bundle-product-tile"
        data-load-immediately="true"
        class="block w-full col-span-1 loading relative"
      >
        <div class="h-full flex flex-col gap-4">
          <div class="aspect-[4/5] lg:aspect-[9/10] bg-secondaryLight"></div>
          <div class="bg-secondaryLight h-4 w-40 pt-5"></div>
          <div class="bg-secondaryLight h-2 w-80"></div>
          <div class="bg-secondaryLight h-3 w-20"></div>
        </div>
      </intersection-loader>
    `;

    generateFilter = (filter) => `
      <button data-filter data-action="${filter}" class="${filter === 'ALL' ? 'text-primaryDark' : ''} text-xs md:text-[15px]">${filter}</button>  
    `;

    generateDropdown = (filters) => `
      <select data-filter-select class="outline-none">
        <option value="">MORE</option>
        ${filters.map((filter) => `
          <option value="${filter}">${filter}</option>  
        `).join('')}
      </select>
    `;

    handleMobileMenuChanges = (() => {
      const body = document.querySelector('body');
      const expand_button = this.querySelector('[data-expand-bag]');
      const checkbox_container = this.querySelector('[data-checkbox-container]');
      const selling_plan_container = this.querySelector('[data-skio-selling-plan]');

      expand_button.addEventListener('click', () => {
        const menu_container = this.querySelector('.transition-max-height');
        menu_container.classList.toggle('expand')

        if (menu_container.classList.contains('expand')) {
          body.classList.add('overflow-hidden');
          expand_button.setAttribute('aria-expanded', true);
          expand_button.classList.remove('-rotate-90');
          expand_button.classList.add('rotate-90');
          checkbox_container.classList.remove('max-lg:hidden');
          selling_plan_container.classList.remove('max-lg:hidden');
        } else {
          body.classList.remove('overflow-hidden');
          expand_button.setAttribute('aria-expanded', false);
          expand_button.classList.add('-rotate-90');
          expand_button.classList.remove('rotate-90');
          checkbox_container.classList.add('max-lg:hidden');
          selling_plan_container.classList.add('max-lg:hidden');
        }
      });
    });

    generateCountBoxes = ((max_size) => {
      const bundle_count_container = this.querySelector('[data-bundle-count]');
      const bundle_count_container_mobile = this.querySelector('[data-bundle-count-mobile]');

      for (let count = 0; count < max_size; count++) {
        const count_box = `<span data-indicator class="h-2 w-2 bg-gainsboro"></span>`;
        const count_box_mobile = `<span data-indicator-mobile class="h-2 w-2 bg-gainsboro"></span>`;

        bundle_count_container.insertAdjacentHTML('beforeend', count_box);
        bundle_count_container_mobile.insertAdjacentHTML('beforeend', count_box_mobile);
      }
    });

    filterProductTiles = ((filter, product_grouping) => {
      const product_tiles = this.querySelectorAll('[data-product-tile]');
      const filtered_ids = product_grouping[filter];

      product_tiles.forEach(product_tile => {
        const product_id = product_tile.dataset.id;

        if (filter === 'ALL') {
          product_tile.classList.add('block');
          product_tile.classList.remove('hidden');
        } else {
          if (filtered_ids.includes(product_id)) {
            product_tile.classList.add('block');
            product_tile.classList.remove('hidden');
          } else {
            product_tile.classList.remove('block');
            product_tile.classList.add('hidden');
          }
        }
      });
    });

    handleFilterClick = ((product_grouping) => {
      const filters_container = this.querySelector('[data-filters]');

      filters_container.addEventListener('click', (ev) => {
        const target = ev.target.closest('[data-action]');

        if (!target) return;

        const filters = this.querySelectorAll('[data-filter]');
        this.active_filter = target.dataset.action;
        filters_container.setAttribute('data-active-filter', this.active_filter);
        this.filterProductTiles(this.active_filter, product_grouping);

        filters.forEach(filter => {
          if (filter.dataset.action === this.active_filter) {
            filter.classList.add('text-primaryDark');
          } else {
            filter.classList.remove('text-primaryDark');
          }
        });

        const select_dropdown = this.querySelector('[data-filter-select]');
        select_dropdown.classList.remove('text-primaryDark');
        select_dropdown.value = '';
      });
    });

    handleFilterInMenuSelection = ((product_grouping) => {
      const select_dropdown = this.querySelector('[data-filter-select]');
      const filters_container = this.querySelector('[data-filters]');

      select_dropdown.addEventListener('change', (ev) => {
        if (ev.target.value) {
          this.active_filter = ev.target.value;
          select_dropdown.classList.add('text-primaryDark');
          const filters = this.querySelectorAll('[data-filter]');

          filters.forEach(filter => {
            filter.classList.remove('text-primaryDark');
          });
        } else {
          this.active_filter = 'ALL';
          const default_filter = this.querySelector('[data-action="ALL"]');

          select_dropdown.classList.remove('text-primaryDark');
          default_filter.classList.add('text-primaryDark');
        }
        
        filters_container.setAttribute('data-active-filter', this.active_filter);

        this.filterProductTiles(this.active_filter, product_grouping);
      });
    });

    updateBagIndicator =(() => {
      const bag_indicators = this.querySelectorAll('[data-indicator]');
      const bag_indicators_mobile = this.querySelectorAll('[data-indicator-mobile');

      bag_indicators.forEach((indicator, index) => {
        if (this.products_in_bag.length > 0 && this.products_in_bag.length > index) {
          indicator.classList.add('shadow-bundleItemAddedShadow');
          indicator.classList.add('bg-accent1');
          indicator.classList.remove('bg-gainsboro');
        } else {
          indicator.classList.remove('shadow-bundleItemAddedShadow');
          indicator.classList.remove('bg-accent1');
          indicator.classList.add('bg-gainsboro');
        }
      });

      bag_indicators_mobile.forEach((indicator, index) => {
        if (this.products_in_bag.length > 0 && this.products_in_bag.length > index) {
          indicator.classList.add('shadow-bundleItemAddedShadow');
          indicator.classList.add('bg-accent1');
          indicator.classList.remove('bg-gainsboro');
        } else {
          indicator.classList.remove('shadow-bundleItemAddedShadow');
          indicator.classList.remove('bg-accent1');
          indicator.classList.add('bg-gainsboro');
        }
      });
    });

    updateBagTilePrice = (() => {
      const bag_items_container = this.querySelector('[data-bag-items]');
      const show_bundle_discount = this.products_in_bag.length >= this.min_bundle_size;
      const show_subscription_discount = this.querySelector('[data-checkbox]').checked;

      bag_items_container.setAttribute('data-show-bundle-discount', show_bundle_discount);
      bag_items_container.setAttribute('data-show-sub-discount', show_subscription_discount);

      const event = new CustomEvent('update-bag-tile-price', {
        detail: {
          show_bundle_discount,
          show_subscription_discount
        }
      });

      document.dispatchEvent(event);
    });

    updatePriceElements = (() => {
      let total_price = 0;
      let subtotal = 0;
      const discount_element = this.querySelector('[data-discount]');
      const subtotal_element = this.querySelector('[data-subtotal]');
      const show_subscription_discount = this.querySelector('[data-checkbox]').checked;

      if (this.products_in_bag.length === 0) {
        discount_element.innerHTML = '';
        subtotal_element.innerHTML = '';
        return;
      }

      this.products_in_bag.forEach((product) => {
        total_price = total_price + product.price;
      });

      if (this.products_in_bag.length >= this.min_bundle_size) {
        const discount_price = Math.floor(total_price * (Number(this.percent_discount_tier[this.min_bundle_size]))) / 100;
        const total_minus_discount = total_price - discount_price;
        const subscription_total =  Math.floor((total_minus_discount * (1 - this.subscription_discount_value / 100)) * 100) / 100;
        const subscription_discount = (total_price - subscription_total).toFixed(2);

        subtotal = show_subscription_discount ? subscription_total : total_minus_discount;

        discount_element.innerHTML = `
          <div>Discount</div>
          <div>$${show_subscription_discount ? subscription_discount : discount_price}</div>
        `;
      } else if (show_subscription_discount) {
        const subscription_discount = Math.floor(total_price * this.subscription_discount_value) / 100;
        subtotal = total_price - subscription_discount;
        
        discount_element.innerHTML = `
          <div>Discount</div>
          <div>$${subscription_discount}</div>
        `;
      } else {
        discount_element.innerHTML = '';
        subtotal = show_subscription_discount ? Math.floor((total_price * (1 - this.subscription_discount_value / 100)) * 100) / 100
          : total_price;
      }

      subtotal_element.innerHTML = `
        <div>Subtotal</div>
        <div><span class="line-through text-grey60">${total_price > subtotal ? `$${total_price.toFixed(2)}` : ''}</span> $${subtotal.toFixed(2)}</div>
      `;
    });

    generateBagTiles = (() => {
      const bag_items_container = this.querySelector('[data-bag-items]');

      bag_items_container.innerHTML = 
        this.products_in_bag.map((product, index) => `
          <intersection-loader 
            data-url="/products/${product.handle}"
            data-section-id="bundle-bag-tile"
            data-load-immediately="true"
            data-bundle-bag-item-index="${index}"
            class="block w-full col-span-1 loading relative"
          >
            <div class="flex gap-4 pt-5 h-[180px] w-full">
              <div class="bg-secondaryLight flex-1 aspect-[4/5] p-3"></div>
              <div class="flex-[2]">
                <div class="flex flex-col h-full pl-3 justify-between">
                  <div class="flex flex-col">
                    <div class="bg-secondaryLight h-4 w-full"></div>
                    <div class="bg-secondaryLight py-3 h-4 w-full"></div>
                  </div>
                  <div class="bg-secondaryLight h-4 pb-3 w-full"></div>
                </div>
              </div>
            </div>
          </intersection-loader>
        `).join('');

      this.updatePriceElements();
      this.updateBagTilePrice();
      this.updateBagIndicator();
      this.updateAddToCartButtonStyling();
    });

    removeBagTile = ((bag_index) => {
      this.products_in_bag.splice(bag_index, 1);
      sessionStorage.setItem('products_in_bag', JSON.stringify(this.products_in_bag));

      this.generateBagTiles();
    });

    updateAddToCartButtonStyling = ((disable_all) => {
      const atc_button = this.querySelector('[data-add-bundle-to-cart]');
      const tile_add_buttons = this.querySelectorAll('[data-bundle-atc]');

      tile_add_buttons.forEach((button) => {
        if (this.products_in_bag.length === this.max_bundle_size || disable_all) {
          button.classList.add('disabled');
        } else {
          button.classList.remove('disabled');
        }
      });

      if (this.products_in_bag.length < this.min_bundle_size || disable_all) {
        atc_button.classList.add('disabled');
      } else {
        atc_button.classList.remove('disabled');
      }
    });

    handleAddToBag = (() => {
      this.addEventListener('click', (ev) => {
        if (!ev.target.hasAttribute('data-bundle-atc')) return;

        ev.preventDefault();

        const product = ev.target.closest('[data-product-tile]');
        const matching_product = this.box_products.find(box_product => box_product.productHandle === product.dataset.productHandle);
        const product_price = matching_product.productVariants[0].price;
        const product_to_push = {
          handle: product.dataset.productHandle,
          price: product_price,
          quantity: 1,
          id: Number(matching_product.productVariants[0].platformId.match(/\d+/)[0]),
        };

        this.products_in_bag.push(product_to_push);
        sessionStorage.setItem('products_in_bag', JSON.stringify(this.products_in_bag));

        this.generateBagTiles();
      });
    });

    handleRemoveFromBag = (() => {
      const bag_items_container = this.querySelector('[data-bag-items]');

      bag_items_container.addEventListener('click', (ev) => {
        if (!ev.target.hasAttribute('data-remove-bag-tile')) return;

        const bag_tile = ev.target.closest('[data-remove-index]');
        const bag_tile_index = Number(bag_tile.getAttribute('data-remove-index'));

        this.removeBagTile(bag_tile_index);
      });
    });

    handleAddToCart = (() => {
      const atc_button = this.querySelector('[data-add-bundle-to-cart]');
      const subscription_checkbox = this.querySelector('[data-checkbox]');
      const selling_plan_container = this.querySelector('[data-skio-selling-plan]');

      atc_button.addEventListener('click', () => {
        let selling_plan_id = null;
        const is_subscribe_and_save = subscription_checkbox.checked;
        const items = [];
        items.length = 0;

        if (is_subscribe_and_save) {
          const selling_plan_buttons = selling_plan_container.querySelectorAll('button');
          const selected_plan = Array.from(selling_plan_buttons).find(button => button.classList.contains('selected'));
          const selected_plan_platform_id = selected_plan.dataset.value;
          selling_plan_id = selected_plan_platform_id.match(/\d+/)[0];
        }

        const combined_items_in_bag = this.products_in_bag.reduce((accumulator, current_item) => {
          const existing_item = accumulator.find(item => item.id === current_item.id);
        
          if (existing_item) {
            existing_item.quantity += current_item.quantity;
          } else {
            accumulator.push({...current_item});
          }
        
          return accumulator;
        }, []);
        
        combined_items_in_bag.forEach((item) => {
          const data = {
            id: item.id,
            quantity: item.quantity,
            selling_plan: selling_plan_id,
            properties: {
              _dynamicBoxIndex: 0,
              _dynamicBoxId: this.dynamic_box.boxId,
            }
          };

          items.push(data);
        });

        this.updateAddToCartButtonStyling(true);

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With':'xmlhttprequest'
          },
          body: JSON.stringify({ items })
        })
          .then(response => response.json())
          .then(() => {
            this.products_in_bag.length = 0;
            sessionStorage.setItem('products_in_bag', JSON.stringify(this.products_in_bag));
            window.location.href = '/cart';
          })
          .catch(error => {
            alert('Error adding items to cart:', error);
          });
      });
    });
    
    async connectedCallback() {
      this.dynamic_box = await this.getDynamicBox(this.product_id);
      this.box_products = this.dynamic_box.selectableProductVariants;
      this.filters.push(...this.dynamic_box.settings.productGroupingOrder);
      this.selling_plan = await this.getSellingPlan(this.box_products[0].productVariants[0].platformId);
      this.min_bundle_size = this.dynamic_box.sizeRange[0];
      this.max_bundle_size = this.dynamic_box.sizeRange[1];
      this.percent_discount_tier = this.dynamic_box.percentDiscountTier;
      const filters_to_show = this.filters.slice(0, 4);
      const filters_in_menu = this.filters.slice(4);
      const product_grouping = this.dynamic_box.settings.productGrouping;
      const bundle_products_container = this.querySelector('[data-bundle-products]');
      const filters_container = this.querySelector('[data-filters]');
      const session_items = JSON.parse(sessionStorage.getItem('products_in_bag'));
      
      if (Array.isArray(session_items) && session_items.length > 0) {
        this.products_in_bag = session_items;
        this.generateBagTiles();
      }

      bundle_products_container.innerHTML = this.box_products.map(product => this.generateProducTileMarkup(product)).join('');
      filters_container.innerHTML = filters_to_show.map(filter => this.generateFilter(filter)).join('');
      this.handleMobileMenuChanges();
      this.generateCountBoxes(this.max_bundle_size);
      this.generateSellingPlanButtons(this.selling_plan);
      this.handleSellingPlanChange();
      this.handleFilterClick(product_grouping);
      this.handleAddToBag();
      this.handleRemoveFromBag();
      this.updateAddToCartButtonStyling();
      this.handleAddToCart();

      if (filters_in_menu.length > 0) {
        filters_container.insertAdjacentHTML('beforeend', this.generateDropdown(filters_in_menu));
        this.handleFilterInMenuSelection(product_grouping);
      }
    }
  }
  customElements.define('skio-bundle', SkioBundle);
}